import { Disposable, IDisposable } from './Disposable';
import PSound from 'pixi-sound';
import { Game } from '../game';

let currentMusic: Music = null;

/**
 * Manages a single music file, hooking it up to the global musicVolume setting.=
 */
export class Music implements IDisposable
{
    private sound: PSound.Sound;
    private volumeListener: Disposable;

    constructor(sound:PSound.Sound, game: Game)
    {
        this.sound = sound;
        this.sound.volume = game.app.state.musicVolume.value * game.musicVolumeMultiplier;
        this.volumeListener = Disposable.fromPropertySubscription(game.app.state.musicVolume, (value) => {
            this.sound.volume = value * game.musicVolumeMultiplier;
        });
    }

    public get playing() { return this.sound.isPlaying; }

    public async play(loop = true)
    {
        if (currentMusic)
        {
            currentMusic.stop();
        }
        currentMusic = this;
        await this.sound.play({loop});
    }

    public stop()
    {
        if (!this.sound) return;
        this.sound.stop();
        if (currentMusic === this)
        {
            currentMusic = null;
        }
    }

    public dispose()
    {
        if (!this.sound) return;

        this.sound.stop();

        // don't destroy the sound - because we didn't load it here, we assume it will be
        // unloaded elsewhere
        this.sound = null;
        this.volumeListener.dispose();
        this.volumeListener = null;
    }

    public destroy()
    {
        this.dispose();
    }
}